import getNestedPropByID from "../../../../functions/getNestedPropByID";
import { ConsultantuseAuth } from "../../../security/ConsultantUseAuth";
import { Request_Letter } from "../api/Request_Letter";

function ConsultantLetterTable({
  Arr_Bookings,
  obj_EC,
  handleRequestLetter,
  handleOpenVISAPage,
  Arr_ECs,
}) {
  const { logoutConsultant } = ConsultantuseAuth();

  return (
    <div
      style={{
        overflowX: "scroll",
        overflowY: "auto",
        maxHeight: "calc(100vh - 300px)",
      }}
    >
      <table id="BookingTable">
        <thead>
          <tr>
            {obj_EC.MetaData?.Admin === "Yes" ? <th>Colleague Name</th> : <></>}
            <th>Name</th>
            <th>Programme Title</th>
            <th>Programme Date</th>
            <th>Programme Varient</th>
            <th>Booking Status</th>
            <th>VISA Info Page</th>
            <th>Require VISA</th>
            <th>Has the student ever been refused a VISA</th>
            <th>
              Which country or countries has the VISA been rejected from
              previously
            </th>
            <th>When was the last time the students VISA was rejected</th>
            <th>Passport Name</th>
            <th>Passport Number</th>
            <th>Passport DOB</th>
            <th>Passport Nationality</th>
            <th>VISA</th>
            <th>Acceptance Letter</th>
            {/* <th>Acceptance with Payment Line</th> */}
          </tr>
        </thead>
        <tbody>
          {Arr_Bookings.map((obj_booking, index) => (
            <>
              <tr key={index}>
                {obj_EC.MetaData?.Admin === "Yes" ? (
                  <td>
                    {getNestedPropByID(
                      Arr_ECs,
                      obj_booking.IPInfo?.EC_ID,
                      "First_Name",
                      "BasicInfo"
                    )}
                  </td>
                ) : (
                  <></>
                )}
                <td>
                  {obj_booking.BasicInfo?.First_Name || ""}{" "}
                  {obj_booking.BasicInfo?.Last_Name || ""}
                </td>
                <td>{obj_booking.BasicInfo?.ProgrammeTitle || ""}</td>
                <td>{obj_booking.BasicInfo?.ProgrammeDate || ""}</td>
                <td>{obj_booking.BasicInfo?.ProgrammeVarient || ""}</td>
                {obj_booking.MetaData?.Archived === "Yes" ? (
                  <td style={{ backgroundColor: "#f1948a" }}>Removed</td>
                ) : obj_booking.MetaData?.Reserved === "Yes" ? (
                  <td style={{ backgroundColor: "#85c1e9" }}>Reserved</td>
                ) : (
                  <td style={{ backgroundColor: "#DAF7A6" }}>Confirmed</td>
                )}
                <td>
                  <button onClick={(e) => handleOpenVISAPage(e, obj_booking)}>
                    Edit Info
                  </button>
                </td>
                <td>
                  {obj_booking.VISA?.Do_you_require_a_VISA_support_letter || ""}
                </td>
                <td>
                  {obj_booking.VISA
                    ?.Has_the_student_ever_been_refused_a_VISA_for_any_county_including_the_UK ||
                    ""}
                </td>
                <td>
                  {obj_booking.VISA
                    ?.Which_country_or_countries_has_the_VISA_been_rejected_from_previously ||
                    ""}
                </td>
                <td>
                  {obj_booking.VISA
                    ?.When_was_the_last_time_the_students_VISA_was_rejected ||
                    ""}
                </td>
                <td>{obj_booking.VISA?.Passport_Name || ""}</td>{" "}
                <td>{obj_booking.VISA?.Passport_Number || ""}</td>{" "}
                <td>{obj_booking.VISA?.Passport_DOB || ""}</td>{" "}
                <td>{obj_booking.VISA?.Passport_Nationality || ""}</td>{" "}
                {obj_booking.MetaData?.Archived === "Yes" ? (
                  <td style={{ backgroundColor: "grey" }}></td>
                ) : obj_booking.VISA?.Passport_Name &&
                  obj_booking.VISA?.Passport_DOB &&
                  obj_booking.VISA?.Passport_Nationality &&
                  obj_booking.VISA?.Passport_Number ? (
                  <td>
                    <button
                      onClick={(e) =>
                        handleRequestLetter(e, "VISA", obj_booking)
                      }
                    >
                      Request
                    </button>
                  </td>
                ) : (
                  <td>Please Complete the VISA Info Page</td>
                )}
                {obj_booking.MetaData?.Archived === "Yes" ? (
                  <td style={{ backgroundColor: "grey" }}></td>
                ) : (
                  <td>
                    <button
                      onClick={(e) =>
                        handleRequestLetter(e, "Acceptance", obj_booking)
                      }
                    >
                      Request
                    </button>
                  </td>
                )}
                {/* {obj_booking.MetaData?.Archived === "Yes" ? (
                  <td style={{ backgroundColor: "grey" }}></td>
                ) : (
                  <td>
                    <button
                      onClick={(e) =>
                        handleRequestLetter(e, "Acceptance_Pay", obj_booking)
                      }
                    >
                      Request
                    </button>
                  </td>
                )} */}
              </tr>
              <tr>
                <td style={{ backgroundColor: "grey" }}></td>
                <td style={{ backgroundColor: "grey" }}></td>
                <td style={{ backgroundColor: "grey" }}></td>
                <td style={{ backgroundColor: "grey" }}></td>
                <td style={{ backgroundColor: "grey" }}></td>
                <td style={{ backgroundColor: "grey" }}></td>
                <td style={{ backgroundColor: "lightgrey" }}></td>
                <td style={{ backgroundColor: "lightgrey" }}></td>
                <td style={{ backgroundColor: "lightgrey" }}></td>
                <td style={{ backgroundColor: "lightgrey" }}></td>
                <td style={{ backgroundColor: "lightgrey" }}></td>
                <td style={{ backgroundColor: "lightgrey" }}></td>
                <td style={{ backgroundColor: "lightgrey" }}></td>
                <td style={{ backgroundColor: "lightgrey" }}></td>
                <td style={{ backgroundColor: "lightgrey" }}></td>
                {/* <td style={{ backgroundColor: "lightgrey" }}></td> */}
              </tr>
            </>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ConsultantLetterTable;
